export function getCurrentUserPermissionsKey(resourceId?: string) {
  return resourceId
    ? ['currentUser', 'scoped-permissions', resourceId]
    : ['currentUser', 'scoped-permissions']
}
